<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 商品中心->公共套餐 -->
    <div class="main2" style="margin-top:-5px;">
      <div class="title">{{ obj.name }}</div>
      <div class="main2">
        <div class="top">
          <el-button
            size="small"
            style="width:150px;border-color:#97c5e9;border-radius:0;margin:-5px 0 5px;font-size:14px;"
            @click="addAddress"
            >新建{{ obj.name }}</el-button
          >
        </div>
        <div class="bottom">
          <el-table
            :data="aryList"
            style="width: 100%;border-right:1px solid #e7e6e4;border-left:1px solid #e7e6e4"
            :cell-style="{
              'text-align': 'center',
              'border-color': '#dbdbdb',
              position: 'relative',
              'background-color': '#fff',
              'border-right': '1px solid #e7e6e4',
            }"
            :header-cell-style="{
              'background-color': '#b6b6b6',
              color: '#000',
              fontSize: '14px',
              fontWeight: '300',
              'text-align': 'center',
            }"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="linkMan" label="收货人" min-width="170">
              <template slot-scope="scope">
                {{ scope.row.linkMan }}
              </template>
            </el-table-column>
            <el-table-column
              prop="cellPhone"
              label="手机号码"
              min-width="160"
            />
            <el-table-column prop="linkAddress" label="地址" min-width="280">
              <template slot-scope="scope">
                <div v-html="getAddress(scope.row)"></div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="说明" min-width="140">
              <template slot-scope="scope">
                {{ scope.row.remark || "" }}
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="150">
              <template slot-scope="scope">
                <div>
                  <el-button
                    size="mini"
                    style="border-color:#97c5e9;border-radius:0;"
                    @click="handleEdit(scope.$index, scope.row)"
                    >修改</el-button
                  >
                  <el-button
                    size="mini"
                    style="border-color:#97c5e9;border-radius:0;"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <br />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button size="mini" style="display:inline-block;">GO</el-button>
      </div>
    </div>
    <!-- 商品中心->公共套餐 -->
    <el-dialog :title="editTitle" :visible.sync="editShow">
      <el-form ref="form" :model="form" :rules="rules" class="df-shdzinp">
        <el-form-item label="姓名" prop="linkMan">
          <el-input v-model="form.linkMan" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="cellPhone">
          <el-input v-model="form.cellPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="选择地区" prop="province" style="margin-top:10px;">
          <el-col :span="6">
            <el-form-item prop="province">
              <el-select
                size="small"
                style="width: 95%"
                v-model="form.province"
                v-on:change="getProv($event)"
                filterable
                placeholder="请选择省份"
              >
                <el-option
                  :value="n.name"
                  :key="index"
                  :label="n.name"
                  v-for="(n, index) in dataProv"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="city">
              <el-select
                size="small"
                style="width: 95%"
                v-model="form.city"
                v-on:change="getCity($event)"
                filterable
                placeholder="请选择城市"
              >
                <el-option
                  :value="n.name"
                  :key="index"
                  :label="n.name"
                  v-for="(n, index) in dataCity"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="selectCountry">
              <el-select
                size="small"
                style="width:95%"
                v-model="form.counties"
                v-on:change="getArea($event)"
                filterable
                placeholder="请选择区/县"
              >
                <el-option
                  :value="n"
                  :key="index"
                  :label="n"
                  v-for="(n, index) in dataArea"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="地址" prop="linkAddress">
          <el-input v-model="form.linkAddress" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            type="textarea"
            rows="6"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:left;" class="dialog-footer">
        <el-button @click="saveEdit">提交</el-button>
      </div>
    </el-dialog>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  getAddresslListRequest,
  addAddressRequest,
  editAddressRequest,
  delAddressRequest,
  cityRequest,
} from "../../../public/js/service";


export default {
  props: ["obj"],
  data() {
    // 1.data
    return {
      totalPages: 1,
      pageNum: 1,
      total: 1,
      pageSize: 10,
      aryList: [],
      token: "", // 1.6.token
      formLabelWidth: "120px",
      editShow: false,
      editTitle: "添加组合",
      form: {},
      dataProv: [],
      dataCity: [],
      dataArea: [],
      rules: {
        linkMan: [{ required: true, message: "请输收货人", trigger: "blur" }],
        cellPhone: [
          { required: true, message: "请输手机号码", trigger: "blur" },
        ],
        province: [
          { required: true, message: "请选择省/市/区", trigger: "blur" },
        ],
        linkAddress: [
          { required: true, message: "请输入地址", trigger: "blur" },
        ],
      },
    };
  },

  components: {},

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },

    getList() {
      // 3.4.获取套餐列表信息
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };

      getAddresslListRequest(data).then((res) => {
        this.aryList = res.data.map((item) => {
          item.amount = 1;
          let vv = [];
          vv.push(item);
          vv.push(item);
          vv.push(item);
          item.children = vv;
          return item;
        });

        this.total = res.totals || 1;
        this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;
      });
    },
    initAddress(vv) {
      for (let j = 0; j < this.dataProv.length; j++) {
        if (this.dataProv[j].name == vv.province) {
          this.dataCity = this.dataProv[j].cityList;
          break;
        }
      }
      for (let k = 0; k < this.dataCity.length; k++) {
        if (this.dataCity[k].name == vv.city) {
          this.dataArea = this.dataCity[k].areaList;
          break;
        }
      }
    },
    getProv: function(vv) {
      let index = 0;
      console.log(index);
      for (let j = 0; j < this.dataProv.length; j++) {
        if (this.dataProv[j].name == vv) {
          index = j;
          break;
        }
      }
      this.dataCity = this.dataProv[index].cityList;
      if (this.dataArea.length > 0) {
        this.form.city = this.dataCity[0].name;
      } else {
        this.form.city = "";
      }
    },
    getCity: function(vv) {
      let index = 0;
      for (let j = 0; j < this.dataCity.length; j++) {
        if (this.dataCity[j].name == vv) {
          index = j;
          break;
        }
      }
      console.log(index);
      this.dataArea = this.dataCity[index].areaList;
      if (this.dataArea.length > 0) {
        this.form.counties = this.dataArea[0];
      } else {
        this.form.counties = "";
      }
    },
    getArea: function(vv) {
      let index = 0;
      for (let j = 0; j < this.dataArea.length; j++) {
        if (this.dataArea[j] == vv) {
          index = j;
          break;
        }
      }
      console.log(index);
      //this.form.counties = this.dataArea[index];
    },
    getAddress(row) {
      return (
        (row["province"] || "") +
        " " +
        (row["city"] || "") +
        " " +
        (row["counties"] || "") +
        " " +
        (row["street"] || "") +
        " " +
        row["linkAddress"]
      );
    },
    addAddress() {
      this.editTitle = "添加" + this.obj.name;
      this.editShow = true;
      this.form = {
        webAddressId: null,
        linkMan: null,
        cellPhone: null,
        province: null,
        city: null,
        counties: null,
        street: null,
        linkAddress: null,
        is_default: null,
        remark: null,
      };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.initAddress(this.form);
    },
    handleEdit(index, row) {
      console.log(index);
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.editTitle = "修改" + this.obj.name;
      this.editShow = true;
      this.form = {
        webAddressId: row.webAddressId,
        linkMan: row.linkMan,
        cellPhone: row.cellPhone,
        province: row.province,
        city: row.city,
        counties: row.counties,
        street: row.street,
        linkAddress: row.linkAddress,
        isDefault: row.isDefault,
        remark: row.remark,
      };
      this.initAddress(this.form);
    },
    handleGoods(index, row) {
      console.log(row);
      this.$refs["edit"].showEdit(row);
    },
    handleDelete(index, row) {
      console.log(row);
      this.delAddress(index, row);
    },
    saveEdit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.confirmSave(this.form);
        }
      });
    },
    confirmSave(item) {
      let _this = this;
      if (item.webAddressId == null) {
        addAddressRequest(item).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            _this.editShow = false;
            setTimeout(() => {
              this.getList();
            }, 300);
          }
        });
      } else {
        editAddressRequest(item).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            _this.editShow = false;
            setTimeout(() => {
              this.getList();
            }, 300);
          }
        });
      }
    },
    closeEditShow() {
      this.editShow = false;
    },
    delAddress(index, row) {
      let _this = this;
      let nn = row.linkMan;
      _this.form.index = index;
      _this.form.webAddressId = row.webAddressId;
      this.$msgbox({
        title: "提示",
        message: "您确定要删除" + nn + "吗?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.delSave(_this.form);
          }
        },
      });
    },
    delSave(item) {
      let _this = this;
      let ids = [];
      ids.push(item.webAddressId);
      let data = { ids: ids };
      delAddressRequest(data).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          setTimeout(() => {
            _this.getList();
          }, 300);
        }
      });
    },
    getBefore() {
      // 3.5.导出之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认导出?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.get();
          }
        },
      });
    },
    loadShow(row) {
      console.log(row);
      if (localStorage.token) {
        this.token = localStorage.token;
        this.getList(); // 4.1.获取套餐列表信息
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      console.log(row);
      console.log(column);
      if (rowIndex < 0) {
        if (columnIndex === 1) {
          return [1, 6];
        } else {
          return [0, 0];
        }
      }
    },
    getCityJson() {
      cityRequest(1).then((res) => {
        if (res) {
          this.dataProv = res;
        }
      });
    },
  },
  watch: {
    obj: function(val) {
      console.log(val);
      if (localStorage.token) {
        this.token = localStorage.token;
        this.getList(); // 4.1.获取套餐列表信息
      }
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getList(); // 4.1.获取套餐列表信息
    }
    this.getCityJson();
  },
};
</script>
<style lang="scss">
.el-table__expanded-cell[class*="cell"] {
  padding: 0px 0px 0px 70px;
}
</style>
<style scoped lang="scss">
$ui-width: 1350px;
@function px2vw($px) {
  @return $px / $ui-width * 100vw;
}

$mainColor1: #e65a5a;
$mainColor2: #dd3242;
$mainColor3: #ff0000;

/* 1.all-container-style-start */
.all-container {
  border-radius: px2vw(6px);
  overflow: hidden;
  box-sizing: border-box;
  padding: px2vw(2px);
  width: 100%;

  > .main {
    flex: 1;
    border-radius: px2vw(6px);
    overflow: hidden;
    box-sizing: border-box;
    padding: px2vw(2px);

    > div {
      border-radius: px2vw(6px);
      overflow: hidden;
      margin-bottom: px2vw(20px);
      overflow: hidden;
      width: 100%;
      box-sizing: border-box;
      padding: px2vw(10px) px2vw(20px);
    }

    > .title {
      font-size: 15px;
      color: #999;
      font-weight: bold;
    }

    > .main {
      > .top {
        flex-wrap: wrap;
        margin: 10px 0;

        > .item {
          padding: 10px 20px;
          background-color: $mainColor1;
          color: #fff;
          border-radius: px2vw(4px);
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 px2vw(10px) px2vw(10px) 0;
        }
      }

      > .bottom {
        > .title {
          background-color: #f5f5f5;
          box-sizing: border-box;
          font-size: 15px;
          font-weight: bold;

          margin-bottom: 14px;
          padding: px2vw(10px);

          > div {
            box-sizing: border-box;
            padding: 0 px2vw(4px);
            text-align: center;

            &:nth-child(1) {
              width: 20%;
              text-align: center;
            }

            &:nth-child(2) {
              flex: 1;
            }

            &:nth-child(3) {
              width: 10%;
            }

            &:nth-child(4) {
              width: 20%;
              padding: 0 px2vw(8px);
            }
          }
        }
        > .none {
          font-size: 15px;
          color: #999;
        }
      }
    }
  }
}
/* 1.all-container-style-start */
</style>
